import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
// import services from 'services';
import axios from 'axios';

const EditCorporateApproval = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const selectedRow = useSelector(selectors.configurator.getSelectedCorporateApproval);
  const editRowId = useSelector(selectors.configurator.getEditedRowIdCorporateApproval);
  const editRow = async () => {
    try {
      if (selectedRow == null) throw new Error('No row selected');
      dispatch(actions.configurator.setEditRowIdCorporateApproval(selectedRow.id));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        utils.app.notify('fail', error.response?.data.message);
        console.error(error.response?.data.message);
        return;
      }
      console.error(error);
    }
  };
  return (
    <CommonButton
      id="edit-corporate-approval"
      action={async () => await editRow()}
      scope="tertiary"
      value={t('editCorporateApproval')}
      customIcon="pen"
      disabled={
        selectedRow == null ||
        editRowId !== undefined ||
        !utils.user.isActionByCompanyActive(actionType.EDIT_CORPORATE_APPROVAL)
      }
    />
  );
};

export default EditCorporateApproval;
